define.alias("ember-in-viewport/services/in-viewport", "settings/services/in-viewport");